export default class CalculatePayRateForBookRequest {
    workerId: string;
    date: string;
}
